import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

function MeniuCont({ onLogout }) {
  const [deschis, setDeschis] = useState(false);
  const [esteAdmin, setEsteAdmin] = useState(false);
  const meniuRef = useRef(null);

  useEffect(function() {
    function handleClickAfara(event) {
      if (meniuRef.current && !meniuRef.current.contains(event.target)) {
        setDeschis(false);
      }
    }

    document.addEventListener('mousedown', handleClickAfara);

    const userString = localStorage.getItem('utilizator');

    if (userString) {
      const user = JSON.parse(userString);

      if (user.email === 'andreibadea253@gmail.com') {
        setEsteAdmin(true);
      }
    }

    return function() {
      document.removeEventListener('mousedown', handleClickAfara);
    };
  }, []);

  function handleToggleMeniu() {
    if (deschis === true) {
      setDeschis(false);
    } else {
      setDeschis(true);
    }
  }

  function handleInchideMeniu() {
    setDeschis(false);
  }

  function handleDeconectare() {
    setDeschis(false);
    onLogout();
  }

  let clasaButon = 'flex flex-col items-center justify-center h-full px-4 transition-colors duration-200 ';

  if (deschis === true) {
    clasaButon = clasaButon + 'text-blue-600';
  } else {
    clasaButon = clasaButon + 'text-gray-600 hover:text-blue-600';
  }

  return (
    <div className="relative h-full flex items-center" ref={meniuRef}>

      <button onClick={handleToggleMeniu} className={clasaButon}>
        <svg className="w-7 h-7 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <span className="text-xs font-bold tracking-wide">Meniu</span>
      </button>

      {deschis === true && (
        <div className="absolute right-0 top-[calc(100%-10px)] w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 py-3 z-50">

          {esteAdmin === true && (
            <div>
              <Link
                to="/admin"
                onClick={handleInchideMeniu}
                className="flex items-center gap-3 px-5 py-3 text-sm font-black text-rose-600 bg-rose-50 hover:bg-rose-100 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                Panou Administrator
              </Link>
              <div className="h-px bg-gray-100 my-2 mx-4"></div>
            </div>
          )}

          <Link
            to="/anunturile-mele"
            onClick={handleInchideMeniu}
            className="flex items-center gap-3 px-5 py-3 text-sm font-bold text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            Gestioneaza anunturile
          </Link>

          <Link
            to="/comenzi"
            onClick={handleInchideMeniu}
            className="flex items-center gap-3 px-5 py-3 text-sm font-bold text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            Comenzile mele
          </Link>

          <Link
            to="/mesaje"
            onClick={handleInchideMeniu}
            className="flex items-center gap-3 px-5 py-3 text-sm font-bold text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
            Mesaje
          </Link>

          <Link
            to="/favorite"
            onClick={handleInchideMeniu}
            className="flex items-center gap-3 px-5 py-3 text-sm font-bold text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
            Favorite
          </Link>

          <Link
            to="/alerte"
            onClick={handleInchideMeniu}
            className="flex items-center gap-3 px-5 py-3 text-sm font-bold text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            Alertele mele
          </Link>

          <Link
            to="/setari"
            onClick={handleInchideMeniu}
            className="flex items-center gap-3 px-5 py-3 text-sm font-bold text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Detaliile mele
          </Link>

          <div className="h-px bg-gray-100 my-2 mx-4"></div>

          <Link
            to="/ajutor"
            onClick={handleInchideMeniu}
            className="flex items-center gap-3 px-5 py-3 text-sm font-bold text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Ajutor & Contact
          </Link>

          <button
            onClick={handleDeconectare}
            className="w-full flex items-center gap-3 px-5 py-3 text-sm font-bold text-red-600 hover:bg-red-50 transition-colors text-left"
          >
            <svg className="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Deconectare
          </button>

        </div>
      )}

    </div>
  );
}

export default MeniuCont;